export class company {
  _id: string;
  companyName: string;
}
